import { render, staticRenderFns } from "./indexWorkServicer.vue?vue&type=template&id=aa80d366&"
import script from "./indexWorkServicer.vue?vue&type=script&lang=ts&"
export * from "./indexWorkServicer.vue?vue&type=script&lang=ts&"
import style0 from "./indexWorkServicer.vue?vue&type=style&index=0&id=aa80d366&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports